import SmartTableStalenessIndicator from "../../../SmartTableStalenessIndicator";
import { COMPUTING_OPACITY_PULSE_CLASS } from "../statusStyles";

const MAX_TITLE_LENGTH = 512;
const MAX_PREVIEW_TEXT_LENGTH = 1_000;

type PendingCellPreviewTone = "pending" | "stale";

interface PendingCellPreviewProps {
  displayText: string;
  hasContent: boolean;
  tone?: PendingCellPreviewTone;
}

export default function PendingCellPreview({
  displayText,
  hasContent,
  tone = "pending",
}: PendingCellPreviewProps) {
  let pendingText = displayText;
  if (!hasContent) {
    pendingText = tone === "stale" ? "Stale" : "Computing…";
  }
  const titleText = pendingText.slice(0, MAX_TITLE_LENGTH);
  const previewText = pendingText.slice(0, MAX_PREVIEW_TEXT_LENGTH);
  const isPending = tone === "pending";
  const textClassName = isPending ? "text-muted-foreground" : "text-amber-700 dark:text-amber-300";
  const containerClassName = isPending
    ? `pointer-events-none flex h-full w-full min-w-0 items-center overflow-hidden ${COMPUTING_OPACITY_PULSE_CLASS}`
    : "pointer-events-none flex h-full w-full min-w-0 items-center gap-1.5 overflow-hidden opacity-75";

  return (
    <div className={containerClassName}>
      {!isPending ? (
        <SmartTableStalenessIndicator
          label={previewText}
          className="h-full w-full flex-1"
          labelClassName="w-full flex-1 text-sm font-normal"
        />
      ) : (
        <span
          className={`w-full min-w-0 flex-1 truncate text-sm ${textClassName}`}
          title={titleText}
        >
          {previewText}
        </span>
      )}
    </div>
  );
}
